import {memo} from 'react';
import {Wrapper} from './checkout.styles';
import {ReviewAndCheckoutSection} from "./sections/reviewAndCheckout/reviewAndCheckout.section";

export const CheckoutPage = memo(() => {
    return (<Wrapper>
            <ReviewAndCheckoutSection/>
        </Wrapper>);
});
